import React, { useState } from 'react';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import { ChevronDown } from '../Icons/index.js';
const FilterGroup = (props) => {
    const active = !!React.Children.toArray(props.children).find(
    // @ts-ignore
    (child) => child?.props?.active);
    const [open, setOpen] = useState(active);
    return (React.createElement(StyledFilterGroup, { active: active },
        React.createElement("div", { onClick: () => setOpen(!open), style: {
                cursor: 'pointer',
                margin: open ? '-20px -20px 0px -20px' : '-20px',
                padding: '20px',
            } },
            React.createElement("h3", null,
                props.name,
                ' ',
                React.createElement(ChevronDown, { style: {
                        transform: open ? 'rotate(180deg)' : undefined,
                    } }))),
        open && React.createElement("div", null, props.children)));
};
export default FilterGroup;
const StyledFilterGroup = styled.div `
  border: 2px solid #d3d3d3;
  margin-bottom: 10px;
  padding: ${THEME.GRID_SPACING}px;
  transition: 0.2s;

  & > div > h3 {
    font-size: 1em;
    margin: -0.3em 0;
    color: ${(props) => (props.active ? THEME.COLOR_ACCENT : '#000000')};

    svg {
      transition: 0.3s;
      float: right;
    }
  }

  &:hover {
    border-color: #969696;
  }
`;
//# sourceMappingURL=FilterGroup.js.map